import { Cache } from 'aws-amplify'
import { navigate } from 'gatsby'
import Api, { spoofMode, spoofedUserId } from './api'

export function fetchAccountSummary() {
  const url = spoofMode ? '/v1/private/admin/account/summary?userId=' + spoofedUserId : '/v1/private/account/summary'
  return new Promise<any>((resolve, reject) => {
    const webpackCompilationHash = Cache.getItem('webpackCompilationHash')

    Api.get('wwwREST', url, {
      headers: {
        'Webpack-Compilation-Hash': webpackCompilationHash ? webpackCompilationHash : ''
      }
    })
      .then(res => resolve(res))

      .catch(err => {
        if (err.response.status === 503) {
          navigate('/maintenance')
        }
        console.error('Error fetch account summary')
        reject(err.message)
      })
  })
}

export function fetchCustomerDetails() {
  const url = spoofMode ? '/v1/private/admin/account/customer?userId=' + spoofedUserId : '/v1/private/account/customer'
  return new Promise<any>((resolve, reject) => {
    Api.get('wwwREST', url, {})
      .then(res => resolve(res))
      .catch(err => {
        if (err.response.status === 503) {
          navigate('/maintenance')
        }
        console.error('Error fetch customer details')
        reject(err.message)
      })
  })
}

export function updateCustomerDetails(customer: {
  name?: string
  surname?: string
  telephone?: string
  password?: string
  billing?: any
  payment?: any
  intent?: any
  emailMarketing?: boolean
  smsMarketing?: boolean
  mailConsentFirstParty?: boolean
  mailConsentThirdParty?: boolean
  marketingCookieConsent?: boolean
  referrer?: string
}) {
  return new Promise<any>((resolve, reject) => {
    const url = spoofMode
      ? '/v1/private/admin/account/customer?userId=' + spoofedUserId
      : '/v1/private/account/customer'
    Api.put('wwwREST', url, { body: customer })
      .then(res => resolve(res))
      .catch(err => {
        if (err.response.status === 503) {
          navigate('/maintenance')
        }
        console.error('Error update customer details')
        reject(err.response)
      })
  })
}
